export default __webpack_public_path__ + "static/media/i (21).46548746.jpg";